import React, { useState ,useEffect} from "react";
import './EducationdetailsofProfile.css';
import Select from 'react-select';
import axios from "axios";
const EducationdetailsofProfile = ({ onNext, onPrevious }) =>{
const [educationDetails, setEducationDetails] = useState([{
    qualifications:'',
    specialization:'',
    institutionName:'',
    board:'',
    cgpa:'',
    yearOfPassing:'',
    uploadCertificate:null
  }]);
  const [qualifications, setQualifications] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
const [formErrors] = useState({});
const [isQualificationFocused, setIsQualificationFocused] = useState([]);


const handleFocus = (index) => {
  const updated = [...isQualificationFocused];
  updated[index] = true;
  setIsQualificationFocused(updated);
};

const handleBlur = (index) => {
  const updated = [...isQualificationFocused];
  updated[index] = false;
  setIsQualificationFocused(updated);
};



useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/qualification`)
      .then((response) => {
        const formatted = response.data.map(q => ({
          value: q.Qualification_NAME,
          label: q.Qualification_NAME
        }));
        setQualifications(formatted);
      })
      .catch((error) => {
        console.error('Error fetching qualifications:', error);
      });
  }, []);
const handleChange = (index, field, value) => {
  const updated = [...educationDetails];
  updated[index][field] = value;
  setEducationDetails(updated);
  
  localStorage.setItem("profileEducationData", JSON.stringify(updated));
};


useEffect(() => {
    const saved = localStorage.getItem("profileEducationData");
    if (saved) {
      setEducationDetails(JSON.parse(saved));
    }
  }, []);


useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= 1950; y--) {
      years.push({ value: y, label: y.toString() });
    }
    setYearOptions(years);
  }, []);

const handleFileChange = (e, fieldName, index) => {
  const file = e.target.files[0];
  if (file) {
    const updated = [...educationDetails];
    updated[index][fieldName] = {
      name: file.name,
      size: file.size,
      type: file.type, // optional for preview, not needed for FormData
    };
    setEducationDetails(updated);
    if (!window._uploadedFiles) window._uploadedFiles = {};
    window._uploadedFiles[`${fieldName}_${index}`] = file;
  }
};



 const handleAddEducation = () => {
  setEducationDetails(prev => [
    ...prev,
    {
      qualifications:'',
      specialization:'',
      institutionName:'',
      board:'',
      cgpa:'',
      yearOfPassing:'',
      uploadCertificate:null
    }
  ]);
};

      const handleSubmit = (e) => {
    e.preventDefault();

   

    // Upload files (example usage - to be handled with FormData at final submission)
    console.log("Final Education Data:", educationDetails);

    onNext();
  };
const lastEntry = educationDetails[educationDetails.length - 1];
const isAddEducationDisabled = !lastEntry.uploadCertificate;


    return(
        <React.Fragment>
            <div className="educationdetailsofprofile-container">
                <div className="eductiondetailsofprofile-box">
                    <h2 className="educationdetailsofprofile-heading">Educational Details</h2>
                    {educationDetails.map((entry, index) => (
                    <div key={index} className="educationofprofile-form">
                       <div className="did-floating-label-content-select">
                          <label className={`did-floating-label-select ${(entry.qualifications || isQualificationFocused[index]) ? 'label-float-select' : ''}`}>
                            <span className="label-text-select">Qualification</span>
                          </label>
                          <Select
                            options={qualifications}
                            value={qualifications.find((q) => q.value === entry.qualifications) || null}
                            onChange={(selected) => handleChange(index, 'qualifications', selected?.value || '')}
                            onFocus={() => handleFocus(index)}
                            onBlur={() => handleBlur(index)}
                            classNamePrefix="react-select"
                            placeholder=" "
                            isClearable
                          />
                        </div>
                        <div className={`did-floating-label-content ${formErrors.specialization ? 'did-error-input' : ''}`}>
                            
                            <input type="text" name="specialization" className="did-floating-input" placeholder=" "  value={entry.specialization}
                            onChange={(e) => { const value = e.target.value;if (/^[a-zA-Z\s]*$/.test(value)) {
                                handleChange(index, 'specialization', value); }}}/>
                            <label className="did-floating-label"><span className="label-text">Specialization</span></label>
                        </div>
                        <div className={`did-floating-label-content ${formErrors.surName ? 'did-error-input' : ''}`}>
                            
                            <input type="text" placeholder=" " className="did-floating-input"  value={entry.institutionName}
                            onChange={(e) => {const value = e.target.value;if (/^[a-zA-Z\s]*$/.test(value)) {
                              handleChange(index, 'institutionName', value);} }}/>
                             <label className="did-floating-label"><span className="label-text">Institution&nbsp;Name</span></label>
                        </div>
                        <div className={`did-floating-label-content ${formErrors.surName ? 'did-error-input' : ''}`}>
                               <input type="text" placeholder=" " className="did-floating-input"  value={entry.board}
                             onChange={(e) => handleChange(index, 'board', e.target.value)}/>
                             <label className="did-floating-label"><span className="label-text">Board</span></label>
                        </div>
                        <div className={`did-floating-label-content ${formErrors.cgpa ? 'did-error-input' : ''}`}>
                            
                            <input type="number" placeholder=" " className="did-floating-input" value={entry.cgpa}
                             onChange={(e) => handleChange(index, 'cgpa', e.target.value)}/>
                             <label className="did-floating-label"><span className="label-text">CGPA</span></label>
                        </div>
                        <div className={`did-floating-label-content ${formErrors.yearOfPassing ? 'did-error-input' : ''}`}>
                          
                            <Select placeholder="Select Year Of Passing" options={yearOptions} value={yearOptions.find((opt) => opt.value === entry.yearOfPassing) || null}
                            onChange={(selected) => handleChange(index, 'yearOfPassing', selected?.value || '')}/>
                        </div>
                        <div className="eductiondetailsofprofile-input-containers-file">
                            <label>Upload Certificate</label>
                          <input
                              type="file"
                              name="uploadCertificate"
                              onChange={(e) => handleFileChange(e, 'uploadCertificate', index)}
                            />

                        </div>
                    </div>
                    ))}
                    <div className="experiencedetails-add-btn-container">
                        <button type="button" className="experiencedetails-table-btn" onClick={handleAddEducation}  disabled={isAddEducationDisabled} >+</button>
                    </div>
                    <div className="educationdetailsofprofile-btns-div">
                        <button type="button" className="educationdetailsofprofile-btn" onClick={onPrevious}>Previous</button>
                        <button type="button" className="educationdetailsofprofile-btn-next " onClick={handleSubmit} >Next</button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default EducationdetailsofProfile;